"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var next_components_1 = require("@dotdev/next-components");
var ProductAddToCart = /** @class */ (function (_super) {
    __extends(ProductAddToCart, _super);
    function ProductAddToCart(props) {
        return _super.call(this, props) || this;
    }
    ProductAddToCart.prototype.render = function () {
        return (React.createElement(Snippets.Button, { type: "submit", id: this.props.variant.id, disabled: this.props.disabled || this.props.text.includes("Pick"), onClick: this.props.handleAddToCart, className: this.props.className, style: "tertiary" }, this.props.text));
    };
    ProductAddToCart.contextType = next_components_1.ShopifyNext.Context;
    return ProductAddToCart;
}(React.PureComponent));
exports.ProductAddToCart = ProductAddToCart;
